/**
 * Feedback Component Constants
 * 
 * Centralized constants for feedback timing, types, and configuration
 */

// Feedback Types
export const FEEDBACK_TYPES = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  NEUTRAL: 'neutral'
};

// Timeouts (in milliseconds)
export const FEEDBACK_TIMEOUTS = {
  COMPLETE: 4000,      // Celebration for completing a set
  CORRECT: 2500,       // Celebration for correct answer
  INCORRECT: 2000,     // Encouragement for incorrect answer
  CLOSE_ANIMATION: 300, // Animation close delay
  CONFETTI_DELAY: 200  // Delay before showing confetti
};

// Confetti Configuration
export const CONFETTI_CONFIG = {
  COMPLETE: {
    PARTICLE_COUNT: 150,
    DURATION: FEEDBACK_TIMEOUTS.COMPLETE
  },
  CORRECT: {
    PARTICLE_COUNT: 50,
    DURATION: FEEDBACK_TIMEOUTS.CORRECT
  },
  INCORRECT: {
    PARTICLE_COUNT: 24,
    DURATION: FEEDBACK_TIMEOUTS.INCORRECT
  }
};

// Encouraging Messages
export const ENCOURAGING_MESSAGES = {
  CORRECT: [
    'You\'re a star! ⭐',
    'So smart! 🧠',
    'Awesome job! 🎉',
    'You rock! 🎸',
    'Super cool! 🌟',
    'Way to go! 🚀',
    'Perfect! 💯',
    'You did it! 🎊',
    'Genius! 🎓',
    'Amazing! ✨',
    'Fantastic! 🌈',
    'Brilliant! 💡'
  ],
  INCORRECT: [
    'Almost there! Keep going! 💪',
    'So close! Try again! 🌟',
    'You\'re learning! That\'s great! 📚',
    'Great try! You got this! 💪',
    'Keep trying! You can do it! 🎯',
    'Nice effort! Try one more time! 🌈',
    'You\'re doing great! Keep learning! 📖',
    'Good try! Let\'s try again! 🌟'
  ]
};

// Feedback Configurations
export const FEEDBACK_CONFIGS = {
  COMPLETE: {
    emoji: '🎉',
    title: 'Great Job!',
    message: 'You finished this set!',
    bgColor: 'from-green-400 via-green-500 to-green-600',
    textColor: 'text-white',
    animation: 'correct-bounce'
  },
  CORRECT: {
    emoji: '🎉',
    title: 'Correct!',
    message: 'Amazing work!',
    bgColor: 'from-green-400 via-green-500 to-green-600',
    textColor: 'text-white',
    animation: 'correct-bounce'
  },
  INCORRECT: {
    emoji: '💪',
    title: 'Nice Try!',
    message: 'You\'re learning!',
    bgColor: 'from-yellow-400 via-orange-400 to-orange-500',
    textColor: 'text-white',
    animation: 'gentle-bounce'
  },
  NEUTRAL: {
    emoji: '🎯',
    title: 'Keep Going!',
    message: 'You\'re learning!',
    bgColor: 'from-purple-400 via-purple-500 to-purple-600',
    textColor: 'text-white',
    animation: 'gentle-bounce'
  }
};

